import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "./Container"

const H4 = styled.h4`
  font-size: 24px;
  padding-top: 50px;
  padding-bottom: 10px;
`

const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 50px;
  padding-left: 20%;
  padding-right: 20%;
`

const VerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Position = styled.p`
  font-size: 18px;
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`
const SurveyResponseSection = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "gatsby-astronaut.png" }) {
        childImageSharp {
          fixed(width: 300, height: 300, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      pie1: file(relativePath: { eq: "Chart1.png" }) {
        childImageSharp {
          fixed(width: 567, height: 369, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      bar: file(relativePath: { eq: "Chart2.png" }) {
        childImageSharp {
          fixed(width: 894, height: 307, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      star: file(relativePath: { eq: "Chart3.png" }) {
        childImageSharp {
          fixed(width: 436, height: 79, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      icon: file(relativePath: { eq: "gatsby-icon.png" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <Container noTop>
        <H4>Have you ever used the Degree Planner website?</H4>
      </Container>
      <ImageContainer>
        <Img fixed={data.pie1.childImageSharp.fixed} />
      </ImageContainer>
      <Container noTop>
        <H4>How will you rate your experience using Degree Planner?</H4>
      </Container>
      <ImageContainer>
        <Img fixed={data.star.childImageSharp.fixed} />
      </ImageContainer>
      <Container noTop>
        <H4>How long did it take you to make your 4 year plan?</H4>
      </Container>
      <ImageContainer>
        <Img fixed={data.bar.childImageSharp.fixed} />
      </ImageContainer>
    </>
  )
}

export default SurveyResponseSection
